import { QrTransaction } from "../../../../interfaces/sales";

export const getQrTransactionInfo = (transaction: QrTransaction) => {
  if (transaction.qr_ticket.uuid) return transaction.qr_ticket.uuid;
  if (transaction.qr_wallet.uuid)
    return `${transaction.qr_wallet.customer.name || "-"} ${
      transaction.qr_wallet.customer.last_name || "-"
    }`;
  return "-";
};
